import { ApiError } from '@/api/http';

/** The server's refusal, in the person's words. */
export function labelFailureCopy(cause: unknown, fallback: string): string {
  if (cause instanceof ApiError) {
    if (cause.code === 'label_exists') return 'A label with that name already exists.';
    if (cause.code === 'label_name_too_long') return 'That name is too long.';
    if (cause.code === 'label_limit') return 'This mailbox already has as many labels as it can hold.';
    if (cause.code === 'label_busy') return 'This label is still being updated. Try again in a moment.';
    if (cause.code === 'conflict') return 'This label was changed elsewhere. Close this and try again.';
    if (cause.message !== '') return cause.message;
  }
  return fallback;
}
